import React, {useState, useEffect} from 'react';
import {
	ContenedorSubtituloPequeño, ContenedorSubtitulo, Subtitulo, Descripcion, Lista, ElementoLista, ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorLista, ContenedorInputConIcono, ContenedorInputconLabel, ContenedorDatosCierre, ContenedorDatosMovil, ElementoListaSimple,
    ElementoListaSimplePasajeros, ListaPasajeros
} from '../elementos/ElementosDeFormulario';
import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';
import { ReactComponent as IconoPasajero } from '.././imagenes/pasajero.svg';
import Alerta from './../elementos/Alerta';
import {format} from 'date-fns';
import es from "date-fns/locale/es";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDollarSign,faIndustry,faCalendarDays,faRoute,faPhone,faReceipt,faUser, faToggleOn,faAddressCard,faPalette,faCar,faCarTunnel,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import {useNavigate} from 'react-router-dom';
import {auth} from '../firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import useObtenerAdmin from './../hooks/useObtenerAdmin'
import { useAuth } from './../contextos/AuthContext';
import Swal from 'sweetalert2';


const FormularioDetalleViaje = ({id, viaje, itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros}) => {

const [fechahoraviaje, cambiarFechahoraviaje] = useState (new Date());
const [fecha_hora_creacion, cambiarfecha_hora_creacion] = useState (new Date());
const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
const [estado, cambiarEstado] = useState ('Programado');
const [movil, CambiarMovil] = useState({numero:"Movil"});
const [comentarios, CambiarComentarios] = useState('');
const [folio, cambiarFolio] = useState('');
const [kmfolio, cambiarKmfolio] = useState('');
const [fechamin, cambiarfechamin] = useState(0);
const [fechamax, cambiarfechamax] = useState(0);
const [muestraFolio, cambiarMuestraFolio] = useState(true);
const [ordenado, CambiarOrdenado] = useState('');
const [alerta, cambiarAlerta] = useState({});
const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
const[fechaFormateada,cambiafechaFormateada] = useState();
const navigate = useNavigate();
const {usuario} = useAuth();
const [TipoUsuario, cambiarTipoUsuario] = useState([]);
const uid = usuario.uid
const UsarioLog = useObtenerAdmin({uid});
const [Escliente, cambiarEscliente] = useState(true);
const [filtroServicio, cambiarFiltroServicio] = useState ('TODOS');
var TAG_v = 0
var Estacionamiento_v = 0
var Encargo_v = 0
var Tarifa_fija_v = 0
var Taximetro_v = 0
var Total_v = 0
var Kms_v = 0
var minutos_v = 0
if (viaje.tag_c === undefined){TAG_v = 0}else{TAG_v = (Number(viaje.tag_c))}
if (viaje.estacionamiento_c === undefined){Estacionamiento_v = 0}else{Estacionamiento_v = (Number(viaje.estacionamiento_c))}
if (viaje.encargo_c === undefined){Encargo_v = 0}else{Encargo_v = (Number(viaje.encargo_c))}
if (viaje.tarifa_fija_c === undefined){Tarifa_fija_v = 0}else{Tarifa_fija_v = Number(viaje.tarifa_fija_c)}
if (viaje.metros_c === undefined){Kms_v = 0}else{Kms_v = (Number(viaje.metros_c)/1000)}
if (viaje.minutos_c === undefined){minutos_v = 0}else{minutos_v = (Number(viaje.minutos_c))}
if (Tarifa_fija_v>0){
  Taximetro_v = Tarifa_fija_v - (TAG_v + Estacionamiento_v)
  Total_v = Tarifa_fija_v
} else {
  if ((viaje.tipo_m==='TaxiEjecutivo' || viaje.tipo_m==='Taxi_Ejecutivo' || viaje.tipo_m==='VAN' || viaje.tipo_m==='Van') && ((Kms_v > 0) || (minutos_v >0))){
    Taximetro_v = Math.ceil(((Kms_v*800)+(minutos_v*160)+2100))
    Total_v = Math.ceil((Taximetro_v + (TAG_v + Estacionamiento_v + Encargo_v)))
  } else {
    if ((Kms_v > 0) || (minutos_v >0)){
    Taximetro_v = Math.ceil(((Kms_v*850)+(minutos_v*170)+400))
    Total_v = Math.ceil((Taximetro_v + (TAG_v + Estacionamiento_v + Encargo_v)))
  }
  }
}

useEffect (()=>{    
if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
{cambiarTipoUsuario('salir')}
else
{    
  if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
    {cambiarTipoUsuario('admin')}
  else
    {{cambiarTipoUsuario('cliente')}}
}
},[UsarioLog]);


useEffect (()=>{    
if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
{cambiarTipoUsuario('salir')
Swal.fire({
  title: 'Usuario sin acceso',
  text: 'Usted no posee acceso al sistema de administración',
  icon: 'warning',
  timer:2000
  })
  try {
          signOut(auth);
          navigate('/iniciar-sesion');
      } catch(error){
          console.log(error);
      }
}
else
{    
  if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
    {cambiarTipoUsuario('admin')
    console.log('entra admin')
    cambiarEscliente(false)
    cambiarFiltroServicio('TODOS')
  }
  
  else
    {{cambiarTipoUsuario('cliente')}
    console.log('entra cliente')
    console.log(UsarioLog.cliente)
    cambiarFiltroServicio(UsarioLog.cliente)
  }
    
}
},[UsarioLog]);

const formatearFecha = (fecha = new Date()) => {
return format((fecha), "EE dd 'de' MMMM 'de' yyyy 'a las' HH:mm", {locale: es});
}
      
useEffect (()=>{
viaje.fecha_hora_programada && cambiarFechahoraviaje(new Date(viaje.fecha_hora_programada));
if(viaje.empresa === 'METRO' || viaje.empresa === 'Metro' )
{cambiarMuestraFolio(false);} else {cambiarMuestraFolio(true);} 
},[viaje]);

useEffect (()=>{    
    if (viaje.fecha_hora_programada !== 'Ingrese Fecha y hora de Viaje')
    {cambiafechaFormateada(formatearFecha(viaje.fecha_hora_programada))}
    else
    {cambiafechaFormateada(viaje.fecha_hora_programada)}
},[fechahoraviaje]);  





    return (  
                
                    <Formulario >
                        <Contenedor>
                        <main>   
                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Traslado</Subtitulo></ContenedorSubtitulo>
                        <ContenedorFiltros>
                        <ContenedorInputconLabel><p>Estado</p><Input name="estado" type="text" placeholder="estado" value={viaje.estado} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Cliente</p> <Input name="cliente" type="text" placeholder="cliente" value={viaje.empresa} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Fecha y Hora</p> <Input name="fechahoraviaje" type="text" placeholder="fechahoraviaje" value={fechaFormateada} disabled = {true}/> </ContenedorInputconLabel>
                        </ContenedorFiltros>
                        <ContenedorFiltros>
                        <ContenedorInputconLabel><p>Folio</p><Input name="folio" type="text" placeholder="Folio " value={viaje.folio} disabled = {true}/></ContenedorInputconLabel>
                        <div hidden={muestraFolio}>
                        
                        <ContenedorInputconLabel><p>KMS</p><Input name="kmfolio" type="text" placeholder="Kilometros" value={viaje.kmfolio} disabled = {true}/></ContenedorInputconLabel>
                        </div>
                        <ContenedorInputconLabel><p>Numero de Vuelo</p><Input name="vuelo" type="text" placeholder="--" value={viaje.n_vuelo} disabled = {true}/></ContenedorInputconLabel>
                        
                        </ContenedorFiltros>
                        

                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Cierre</Subtitulo></ContenedorSubtitulo>

                        <ContenedorDatosCierre>
                        <ContenedorInputconLabel><p>Vale</p><Input name="vale_c" type="text" placeholder="--" value={viaje.vale_c} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>KMS</p><Input name="metros_c" type="text" placeholder="--" value={Kms_v} disabled = {true}/></ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Minutos</p><Input name="minutos_c" type="text" placeholder="--" value={minutos_v} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>TAG</p> <Input name="tag_c" type="text" placeholder="--" value={TAG_v} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Estacionamiento</p> <Input name="estacionamiento_c" type="text" placeholder="--" value={Estacionamiento_v} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Serv. Encargo</p> <Input name="encargo_c" type="text" placeholder="--" value={Encargo_v} disabled = {true}/> </ContenedorInputconLabel>
                        </ContenedorDatosCierre>


                        <ContenedorDatosCierre>
                        <ContenedorInputconLabel><p>Movil</p><Input name="numero_m" type="text" placeholder="--" value={viaje.numero_m} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Tipo Movil</p> <Input name="tipo_m" type="text" placeholder="--" value={viaje.tipo_m} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Taximetro</p> <Input name="taximetro_m" type="text" placeholder="--" value={Taximetro_v} disabled = {true}/></ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Tarifa Fija</p> <Input name="taximetro_m" type="text" placeholder="--" value={Tarifa_fija_v} disabled = {true}/></ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Valor Total</p> <Input name="total_c" type="text" placeholder="--" value={Total_v} disabled = {true}/> </ContenedorInputconLabel>
                        </ContenedorDatosCierre>
                        
                        <ContenedorDatosCierre>
                        <div hidden={true/*Escliente*/}><ContenedorInputconLabel><p>Metros App</p><Input name="distancia_traslado" type="text" placeholder="--" value={(viaje.distancia_traslado)} disabled = {true}/></ContenedorInputconLabel></div>
                        <div hidden={true/*Escliente*/}><ContenedorInputconLabel><p>Minutos App</p><Input name="minutos_traslado" type="text" placeholder="--" value={(viaje.minutos_traslado)} disabled = {true}/> </ContenedorInputconLabel></div>
                        </ContenedorDatosCierre>


                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Movil</Subtitulo></ContenedorSubtitulo>
                        <ContenedorDatosMovil>
                        <ContenedorInputconLabel><p>Patente</p> <Input name="patente" type="text" placeholder="Patente" value={viaje.patente_m} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Color</p> <Input name="color" type="text" placeholder="Color" value={viaje.color_m} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Telefono</p><Input name="telefono_m" type="text" placeholder="Telefono Conductor" value={viaje.telefono_m} disabled = {true}/></ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Nombre</p> <Input name="conductor" type="text" placeholder="Conductor" value={viaje.nombre_m} disabled = {true}/> </ContenedorInputconLabel>
                        </ContenedorDatosMovil>
                        <ContenedorSubtituloPequeño><Subtitulo>Comentarios</Subtitulo></ContenedorSubtituloPequeño>                      
                        <Input name="Comentarios2" type="text" placeholder="--" value={viaje.comentarios} disabled = {true}/>

                        <ContenedorSubtitulo>
                            <Subtitulo>&nbsp;&nbsp;Pasajeros &nbsp;&nbsp;&nbsp;</Subtitulo>   
                        </ContenedorSubtitulo>

                        <ListaPasajeros>
                        {listadoPasajeros.map((pasajerol, index) =>{
                                return(
                                <ElementoListaSimplePasajeros key={pasajerol.id}>
                        <ContenedorDatosMovil>
                        <ContenedorInputconLabel><p>Rut/ CC</p> <Input name="rfc" type="text" placeholder="--" value={pasajerol.rfc} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Cliente</p> <Input name="cliente" type="text" placeholder="Cliente" value={pasajerol.cliente} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Telefono</p> <Input name="telefono_p" type="text" placeholder="Telefono Pasajero" value={pasajerol.telefono} disabled = {true}/> </ContenedorInputconLabel>
                        <ContenedorInputconLabel><p>Nombre</p><Input name="nombre_p" type="text" placeholder="Nombre Pasajero" value={pasajerol.nombre} disabled = {true}/></ContenedorInputconLabel>
                        </ContenedorDatosMovil>
                                </ElementoListaSimplePasajeros>
                                )
                        })}
                        </ListaPasajeros>
                        </main>

                        </Contenedor>
                        <Alerta 
                            tipo={alerta.tipo}
                            mensaje={alerta.mensaje}
                            estadoAlerta={estadoAlerta}
                            cambiarEstadoAlerta={cambiarEstadoAlerta}
                        />
                    </Formulario>
    );
}
 
export default FormularioDetalleViaje;